/**
 * GET /api/main/exec — every exec-dashboard panel in one payload
 * (quick-261104-ia3, John 2026-11-04 /main redesign). 503 until the sync-worker's
 * first tick fills agg_exec_panel; tiles render their empty state meanwhile.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { MetricError } from './useCroScorecard.js';
import type { ExecResponse } from '@saledash/shared';

export function useExecPanels(): UseQueryResult<ExecResponse, MetricError> {
  return useQuery<ExecResponse, MetricError>({
    queryKey: ['main', 'exec'],
    queryFn: ({ signal }) => apiFetch<ExecResponse>('/api/main/exec', { signal }),
    staleTime: 60_000,
    retry: 2,
  });
}
